import * as jwtDecode from "jwt-decode";
import * as Cryptr from "cryptr";
import * as moment from "moment";
import * as _ from "lodash";

import { CRYPTR_SECRET_KEY } from "./Consts";
import { AUTH_USER_TOKEN } from "./LocalStorage";

const cryptr = new Cryptr(CRYPTR_SECRET_KEY);

/**
 * Get user Id
 */
export const getUserId = (): any => {
  if (window.localStorage.getItem(AUTH_USER_TOKEN)) {
    const token = window.localStorage.getItem(AUTH_USER_TOKEN);
    const decodedToken = !token ? null : jwtDecode(token);
    return decodedToken;
  }

  return {};
};

export const getArrayFromObject = (object: object): Array<any> => {
  const arrayFromObject = [];

  for (const item in object) {
    if (Object.keys(object[item]).length > 0) {
      arrayFromObject.push({
        ...object[item]
      });
    }
  }

  return arrayFromObject;
};

/**
 * Checks if a token has not expired
 * @returns {*}
 */

export const validateToken = (token: any): boolean => {
  if (!token) {
    return false;
  }
  try {
    const decodedJwt: any = jwtDecode(token);
    return decodedJwt.exp >= Date.now() / 1000;
  } catch (e) {
    return false;
  }
};

// Convert text to a selector
export const convertToSelector = (text: string): string => {
  const newText = text.toLowerCase();
  return newText.replace(" ", "-");
};

// Decrypt encrypted string value
export const decryptEncryptedStringValue = (
  encryptedString: string
): string => {
  return cryptr.decrypt(encryptedString);
};

// Capitalize first letter
export const capitalizeFirstLetter = (text: string): string => {
  return text.charAt(0).toUpperCase() + text.slice(1);
};

/** Get moment date from string format */
export const getMomentDateFromString = (date: string): any => {
  const dateArray = date.split("/");
  const dateString = `${dateArray[1]}-${dateArray[0]}-${dateArray[2]}`;
  return moment(dateString, "MM-DD-YYYY");
};

export const addLeadingZero = (time: number): any => {
  if (time <= 9) {
    return `0${Math.floor(time)}`;
  }
  return time;
};

// Order array by the most recent created object (desc)
export const orderDatasetByDateDesc = (dataset: Array<any>): Array<any> => {
  return !dataset || !dataset.length
    ? dataset
    : _.orderBy(dataset, "createdAt", "desc");
};



// WEBPACK FOOTER //
// ./src/Utils/Helpers.ts